module.exports = __webpack_public_path__ + "static/media/Abbu.a1c7bf56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Abbu.jpg
// module id = 433
// module chunks = 17